import React, {Component} from 'react';
import {
  Container,
  Divider,
  Header,
  Image,
  Menu,
}                         from 'semantic-ui-react';
import _                  from 'lodash';
import ReactHtmlParser    from 'react-html-parser';
import PropTypes          from 'prop-types';
import {isMobile}         from 'react-device-detect';

// Global
import getMessage         from '../../global/getMessage';
// Controller
import globalController   from '../../global/globalcontroller';
// Images
import lesson             from '../../images/singing_lesson.jpg';
// Style
import                    '../MainStyle/MainTwo.scss';
import                    './MainSingingLesson.scss';

const propTypes = {
  content : PropTypes.arrayOf(PropTypes.object),
  lang    : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainSingingLesson extends Component {

  constructor(props) {
    super(props);

    this.state = {active: 0};

    this.handleItemCLick = this.handleItemCLick.bind(this);
  }

  handleItemCLick(e,v) {
    this.setState({active: v.index});
  }

  render() {
    const {lang} = this.props;
    const contentMsg = this.props.content || getMessage('section.lesson.content', lang);
    const content2Msg = this.props.content || getMessage('section.lesson.content2', lang);
    const content = [];
    const content2 = [];

    _.forOwn(contentMsg, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });
    _.forOwn(content2Msg, (value, key) => {
      content2.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    const menuItems = [
      {
        active  : this.state.active === 0,
        content : getMessage('section.lesson.menu.lesson',lang),
        key     : 'lesson',
        icon    : 'music',
      },
      {
        active  : this.state.active === 1,
        content : getMessage('section.lesson.menu.coaching',lang),
        key     : 'coaching',
        icon    : 'comment',
      },
      {
        active  : this.state.active === 2,
        content : getMessage('section.lesson.menu.voice',lang),
        key     : 'voice',
        icon    : 'microphone',
      },
    ];

    const contentsTab = {};
    menuItems.forEach((menu, i) => {
      if (menu.content.length) {
        contentsTab[i] = [];
        const contentMsg = getMessage(`section.lesson.menucontent.${menu.key}`, lang);
        _.forOwn(contentMsg, (value, key) => {
          contentsTab[i].push(
            <p
              className='lesson-menu'
              key={key}
            >
              {value}
            </p>
          );
        });
      }
    });

    const videoSrc = 'https://www.youtube.com/embed/7E8KSnosTyQ?rel=0&modestbranding=1';
    return (
      <Container className='sgr-mainHome-grid-two-sub main-lesson'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>

            <Image
              avatar
              size='small'
              src={lesson}
            />
            {ReactHtmlParser(getMessage('menu.lesson.content', lang))}
          </Header.Content>
        </Header>

        {content}

        <Menu
          attached='top'
          items={menuItems}
          onItemClick={this.handleItemCLick}
          tabular
        />

        {contentsTab[this.state.active]}

        {content2}

        <div
          className='container'
          style={{height: isMobile ? '190px' : '459px'}}
        >
          <iframe
            className='player'
            frameBorder='0'
            height='100%'
            src={videoSrc}
            type='text/html'
            width='100%'
          />
        </div>

      </Container>
    );
  }

}

MainSingingLesson.propTypes = propTypes;
MainSingingLesson.defaultProps = defaultProps;

export default globalController(MainSingingLesson);



// WEBPACK FOOTER //
// ./src/organisms/MainSingingLesson/MainSingingLesson.js